<div
  class="backgroundLogin"
  [ngClass]="{ backgroundEffect: backEffect }"
  [style.background-image]="
    'url(./assets/img/' + customTheme + '/imagesLogin/' + img + ')'
  "
></div>

<div class="container-login">
  <mat-card class="login-card">
    <mat-form-field
      class="login-language"
      style="visibility: hidden; display: none"
    >
      <mat-select
        [(value)]="languageDefault"
        (selectionChange)="changeLanguage($event)"
      >
        <mat-option
          *ngFor="let language of languages"
          [value]="language.FullCode"
          [title]="language.Name"
        >
          {{ language.ShortCode }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <img id="tower-img" class="login-logo" [src]="logoUrl" />

    <form (ngSubmit)="onSignin(false)" [formGroup]="form" class="form-login">
      <mat-form-field>
        <input
          matInput
          name="username"
          placeholder="{{ 'k000079' | translate }}"
          formControlName="username"
          class="ipt-item"
          maxlength="50"
        />
        <!-- Token: User -->
      </mat-form-field>

      <mat-form-field>
        <input
          matInput
          name="password"
          placeholder="{{ 'k000002' | translate }}"
          [type]="hide ? 'password' : 'text'"
          formControlName="password"
          class="ipt-item"
          maxlength="30"
        />

        <mat-icon
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <fa-icon icon="{{ hide ? 'eye' : 'eye-slash' }}" size="xs"></fa-icon>
        </mat-icon>
      </mat-form-field>
      <a class="login-recover" routerLink="/recover-password">{{
        'k000627' | translate
      }}</a>
      <!-- Token: Recover password -->
      <button
        mat-raised-button
        class="buttonPortal login-submit"
        type="submit"
        [disabled]="form.invalid"
      >
        <span *ngIf="!faSpinner">{{ 'k000005' | translate }}</span>

        <fa-icon [icon]="faSpinner" [spin]="true" *ngIf="faSpinner"></fa-icon>
      </button>
    </form>

    <a *ngIf="allowOpenNewAccount" class="login-signUp" routerLink="/signup">{{
      'k002393' | translate
    }}</a>
    <!-- Token: Open an account -->
    <a *ngIf="allowOpenNewAccountWithEmail" class="login-register" routerLink="/register">{{
      'ck3jByQyG1GngxCWiBhe8X' | translate
    }}</a>
    <!-- Token: First time? Register here -->
    <span class="spanVersion">{{ version }}</span>
  </mat-card>
</div>
